import React, { useEffect, useState } from "react";
import "../css/Hero.css";
import CommonButton from "../Components/CommonButton";

import TextField from "@mui/material/TextField";
import { Drawer } from "antd";
// import WebsideImg from "../../../src/assets/images/web.jpg";
import WebsideImg from "../../src/assets/images/web.jpg";
import { ArrowRightAltOutlined } from "@mui/icons-material";

const ESignDetailDrawer = ({
  resetDetails,
  mydocument,
  user,
  loadingPdf,
  firstName,
  fullName,
  setFullName,
  setFirstName,
  lastName,
  setLastName,
  email,
  signatories_category,
  setSignatories_category,
  isLoading,
  handleEmailChange,
  handleSubmit,
  onClose,
  setOpen,
  open,
  isFormValid,
}) => {
  const showDrawer = () => {
    setOpen(true);
  };

  console.log({
    user,
    mydocument,
  });

  // const [fullName, setFullName] = React.useState("");
  // const [isFormValid, setIsFormValid] = useState(false);

  // useEffect(() => {
  //   // Check if all fields are filled
  //   const isValid = fullName.trim() !== "" && email.trim() !== "";
  //   setIsFormValid(isValid);
  // }, [fullName, email]);

  // useEffect(() => {
  //   if (!(user && user.token && mydocument && mydocument.documentId)) {
  //     setOpen(true);
  //   }
  // }, [user, mydocument]);

  return (
    <div className="drawer-esign-parent-container">
      {!(user && user.token && mydocument && mydocument.documentId) ? (
        <CommonButton
          label={
            <span className="d-flex align-items-center">
              Continue <ArrowRightAltOutlined />
            </span>
          }
          onClick={showDrawer}
          className="floatingButton"
          variant={"contained-variant"}
        />
      ) : null}

      <Drawer
        title="Enter your details"
        placement="right"
        onClose={() => setOpen(false)}
        className="drawer-esign-container"
        open={open}
      >
        <div className="right-container-pdf-view-header">
          <div style={{ position: "relative", display: "inline-block", marginTop: "30px" }}>
            <div
              style={{
                borderLeft: "3px solid #9B0242",
                borderTop: "3px solid #9B0242",
                borderRight: "3px solid transparent",
                borderBottom: "3px solid #9B0242",
                borderTopLeftRadius: "20px",
                borderBottomLeftRadius: "20px",
                padding: "25px 60px 20px 25px",
                position: "relative",
                display: "inline-block",
                minWidth: "250px",
              }}
            >
              {/* Signature Text */}
              <div
                style={{
                  fontFamily: "'Dancing Script', cursive",
                  fontSize: "28px",
                  color: "#000",
                  whiteSpace: "nowrap",
                  padding: "6px",
                }}
              >
                {fullName ? fullName : "Your Signature"}
              </div>
            </div>

            {/* Top-right label */}
            <div
              style={{
                position: "absolute",
                top: "-10px",
                left: "50%",
                transform: "translateX(20%)",
                fontSize: "14px",
                color: "#9B0242",
                fontWeight: "600",
                background: "#fff",
                padding: "0 4px",
              }}
            >
              Signed with Legitt
            </div>

            {/* Bottom-right truncated ID */}
            <div
              style={{
                position: "absolute",
                bottom: "-14px",
                right: "0",
                fontSize: "12px",
                color: "#9B0242",
                fontWeight: "500",
                background: "#fff",
                padding: "0 4px",
              }}
            >
              user sign id
            </div>
          </div>
          {/* <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={WebsideImg} style={{ width: 300, maxWidth: "70%" }} alt="Website" />
          </div> */}
          {/* <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="signatories-category"
              value={signatories_category}
              style={{
                width: "100%",
                display: "flex",

                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10px",
              }}
              onChange={(e) => {
                setSignatories_category(e.target.value);
              }}
            >
              <div className="self-container">
                <div className="flex items-center justify-start gap-3 w-full">
                  <div className="self-container-icon-container">
                    <img src={require("../assets/icons/self-2.png")} className="self-icon" />
                  </div>
                  <div className="self-sign-text">
                    <FormControlLabel
                      value="self_only"
                      control={<Radio name="signatories-category" />}
                      label="Only I need to sign"
                      labelPlacement="start"
                      // disabled={!allowDocumentEdit}
                    />
                  </div>
                </div>
              </div>

              <div className="self-other-container ">
                <div className="flex items-center justify-start gap-3 w-full">
                  <div className="self-container-icon-container">
                    <img src={require("../assets/icons/self-other-2.png")} className="self-icon" />
                  </div>
                  <div className="self-sign-text">
                    <FormControlLabel
                      value="multiple"
                      control={<Radio name="signatories-category" />}
                      label="Others need to sign too"
                      // disabled={!allowDocumentEdit}
                      labelPlacement="start"
                    />
                  </div>
                </div>
              </div>

              <div className="other-container">
                <div className="flex items-center justify-start gap-3 w-full">
                  <div className="self-container-icon-container">
                    <img src={require("../assets/icons/other-2.png")} className="self-icon" />
                  </div>
                  <div className="self-sign-text">
                    <FormControlLabel
                      value="others_only"
                      control={<Radio name="signatories-category" />}
                      labelPlacement="start"
                      label="Send to others only (I won't sign)"
                      // disabled={!allowDocumentEdit}
                    />
                  </div>
                </div>
              </div>
            </RadioGroup>
          </FormControl> */}

          <div className="information-container" style={{ borderTop: "none" }}>
            <div className="email-container">
              {/* <Input
                             size="large"
                             placeholder="Name"
                             prefix={<UserOutlined />}
                           /> */}
              <div className="d-flex gap-3">
                <TextField
                  className="emailInput"
                  label="Full Name"
                  required
                  onChange={(e) => setFullName(e.target.value)}
                  value={fullName}
                  variant="outlined"
                  disabled={isLoading || loadingPdf}
                />
              </div>
              <TextField
                className="emailInput"
                label="Email Address"
                required
                variant="outlined"
                value={email}
                onChange={handleEmailChange}
                disabled={isLoading || loadingPdf}
              />
              {/* <Input
                             size="large"
                             placeholder="Email Address"
                             prefix={<MailOutlined />}
                           /> */}
            </div>

            <div className="helper-text-for-mail-input">
              Give your name and email address to let others know who you are.
            </div>
          </div>
          <div className="Button-container">
            <CommonButton
              label="Cancel"
              size="small"
              variant="outlined"
              onClick={() => setOpen(false)}
            />
            <CommonButton
              label="Next"
              size="extraLarge"
              variant="contained-variant"
              disabled={!isFormValid || isLoading || loadingPdf}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </Drawer>
    </div>
  );
};
export default ESignDetailDrawer;
